import { Link } from 'react-router-dom';
import { venuesData } from '@/mocks/home';

export default function VenuesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-2">优质场馆</h2>
            <p className="text-foreground-600 text-base">全国200+优质体育场馆，随时可约</p>
          </div>
          <Link
            to="/category/venues"
            className="flex items-center gap-1.5 text-primary-600 font-medium text-sm whitespace-nowrap hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部场馆 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {venuesData.map((venue) => (
            <Link
              key={venue.id}
              to={`/category/venues`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={venue.image}
                  alt={venue.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium">
                  {venue.type}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-900">{venue.name}</h3>
                  <span className="flex items-center gap-1 text-accent-500 text-sm">
                    <i className="ri-star-fill text-xs"></i> {venue.rating}
                  </span>
                </div>
                <p className="text-foreground-500 text-sm mb-3 flex items-center gap-1">
                  <i className="ri-map-pin-line text-xs"></i> {venue.address}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1.5 flex-wrap">
                    {venue.facilities.map((f) => (
                      <span key={f} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                        {f}
                      </span>
                    ))}
                  </div>
                  <span className="font-heading text-base font-bold text-primary-600 whitespace-nowrap">{venue.price}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}